import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
// import { Service } from 'service';
import { environment } from 'src/environments/environment';
import { AccessLevel } from '../models/access-level';
import { Campus } from '../models/campus';
import { Facility } from '../models/facility';
import { FunctionalArea } from '../models/functional-area';
import { MaapLocation } from '../models/location';
import { Region } from '../models/region';
import { ServiceGroup } from '../models/service-group';

@Injectable({
  providedIn: 'root'
})

export class AccountManagementService {
  private http = inject(HttpClient);

  startDate:Date = new Date();
  endDate:Date = new Date();
  regions!: Region[]
  campuses!: Campus[]
  facilities!: Facility[]
  serviceGroups!: ServiceGroup[]
  functionalAreas!: FunctionalArea[]
  locations!: MaapLocation[]
  accessLevels!: AccessLevel[]


  getRegions() {
    return this.http.get(environment.apiUrl + "fetch/regions").pipe(map(resp => {
      return (resp as any)["docs"].map((region: any) => ({ label: region.label, value: region._id }));
    }));
  }

  getCampusesFromRegionId(regionIds: string[]) {
    const params = regionIds?.length ? `?regionIds=${regionIds.join(',')}` : '';
    return this.http.get(environment.apiUrl + "fetch/campuses" + params)
      .pipe(map(resp => {
        return (resp as any)["docs"].map((campus: any) => ({ label: campus.label, value: campus._id }));
      }));
  }

  getFacilitiesFromCampusId(campusIds: string[], regionIds: string[]) {
    let params = new HttpParams();

    if (campusIds?.length) {
      params = params.set('campusIds', campusIds.join(','));
    }

    if (regionIds?.length) {
      params = params.set('regionIds', regionIds.join(','));
    }

    return this.http.get(environment.apiUrl + "fetch/facilities", { params })
      .pipe(map(resp => {
        return (resp as any)["docs"].map((facility: any) => ({ label: facility.label, value: facility._id }));
      }));
  }

  getAllFacilties(){
    return this.http.get(environment.apiUrl + "fetch/facilities").pipe(map(resp => {
      return (resp as any)["docs"].map((facility: any) => ({ label: facility.label, value: facility._id }));
    }));
  }

  getUserPagedData(skip: any, limit: any, search: any) {
    return this.http.get(environment.apiUrl + 'get/users?$skip=' + skip + '&$limit=10&userSearch='+search)
  }

  public saveUser(userScope: any) {
    return this.http.post(environment.apiUrl + 'add/user', userScope);

  }

  public deleteUser(id: any) {
    return this.http.delete(environment.apiUrl + 'user/' + id)
  }

  getDefaultCampusesFromRegionId(id: any) {
    return this.http.get(environment.apiUrl + "fetch/defaultCampuses?region=" + id).pipe(map(resp => {
      return (resp as any)["docs"].map((campus: any) => ({ label: campus.name, value: campus.id }));
    }));
  }
  
  getDefaultFacilitiesFromCampusId(id: any) { 
    return this.http.get(environment.apiUrl + "fetch/defaultFacilities?campus=" + id).pipe(map(resp => {
      return (resp as any)["docs"].map((facility: any) => ({ label: facility.name, value: facility.id }));
    }));
  }

  getLocationGroupsByFacility(regionIds: string[], campusIds: string[], facilityIds: string[]) {
    let params = facilityIds?.length ? `?facilityIds=${facilityIds.join(',')}` : '?facilityIds=All';
    params += campusIds?.length ? `&campusIds=${campusIds.join(',')}` : '&campusIds=All';
    params += regionIds?.length ? `&regionIds=${regionIds.join(',')}` : '&regionIds=All';

    return this.http.get<{ locs?: unknown[] }>(environment.apiUrl + "fetch/location-groups" + params).pipe(map(resp => {
      return (Array.isArray(resp.locs) ? resp.locs : [])
        .map((group): string | undefined => {
          const record = group !== null && typeof group === 'object'
            ? group as { name?: unknown; group?: unknown }
            : undefined;
          return [record?.name, record?.group, group].find((value): value is string =>
            typeof value === 'string' && !!value.trim() && value.trim() !== '[object Object]'
          );
        })
        .filter((name): name is string => name !== undefined)
        .map((name) => ({ name: name.trim() }));
    }));
  }

}
